import React from "react";
import { Form, Switch } from "antd";

const UISwitch = ({ label, name, defaultValue, disabled, onSwitch }) => {
  return (
    <Form.Item
      label={label}
      name={name}
      valuePropName="checked"
      initialValue={!!defaultValue}
    >
      <Switch disabled={disabled} onChange={onSwitch} />
    </Form.Item>
  );
};

export default UISwitch;
